import { postFetch } from '../fetch';
import { apiConfig } from '../config';

// 204 - если применен
// 400 - если код не найден или уже применен
export function postTeacherReservePromocode({ userId, promocode }: { userId: number; promocode: string }) {
    const { apiPostTeacherReservePromocode } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostTeacherReservePromocode}?user_id=${userId}`, { promocode });
}
